import Pagination from "components/Common/newPagination";
import React, { Suspense, useState, useEffect } from "react";
import ReleaseService from "./ReleaseService";
import ViewContractReleaseAsset from "./ViewContractReleaseAsset";
import DeleteDialogueBox from "components/Common/deleteDialogue";
import ReleaseLinking from "./releaseLinking";
import { CommonUtilities } from "commonUtils";

export default function AssociatedReleases(contractDetails: any) {

    let [totalRows, setTotalRows] = useState(0);
    let [deleteJob, setDeleteJob] = useState(false)
    let [deleteJobName, SetdeleteJobName] = useState('')
    let [viewContract, setviewContract] = useState(false);
    let [confirmMessage, setConfirmMessage] = useState('');
    let [ReleaseLinkingOpen, setReleaseLinkingOpen] = useState(false)
    let [AssociatedRelease, initAssociatedRelease] = useState<any>([]);
    let [viewContractSelect, setviewContractSelect] = useState<any>([]);
    let [AssociatedReleaseTemp, initAssociatedReleaseTemp] = useState<any>([]);

    const Data: any = { pageSize: 10, pageNumber: 1, contractRefNum: contractDetails?.contractDetails?.contractRefNum }

    const handleNameOnChange = (n: any) => {
        Data.pageNumber = n.pageNumber;
        Data.pageSize = n.pageSize;
        AssociatedRelease = AssociatedReleaseTemp.slice((Data.pageNumber - 1) * Data.pageSize, (Data.pageSize * Data.pageNumber))
        initAssociatedRelease(AssociatedRelease);
    }

    useEffect(() => {
        getReleases()
    }, []);

    const getReleases = () => {
        ReleaseService.AssociatedRelease(Data).then((res) => {
            AssociatedRelease = res.slice((Data.pageNumber - 1) * Data.pageSize, (Data.pageSize * Data.pageNumber))
            initAssociatedRelease(AssociatedRelease);

            AssociatedReleaseTemp = res
            initAssociatedReleaseTemp(AssociatedReleaseTemp)
            setTotalRows(res[0].totalRows)
        })
    };

    const ViewContractReleaseChange = (e: any) => {
        viewContract = false
        setviewContract(viewContract)
    }

    const deleteTask = (e: any) => {
        deleteJobName = e
        SetdeleteJobName(deleteJobName)
        if (e === "delete") {
            setDeleteJob(true);
        }

        if (e === "UpdateReleasesplits") {
            setConfirmMessage(" update release splits");
            setDeleteJob(true);
        }
    };

    const deleteConfirmation = (e: any) => {
        if (e === 1) {

            if (deleteJobName == "UpdateReleasesplits") {
                ReleaseService.validateReleaseMetaData()
            }
        }
        setDeleteJob(false);
    }

    const onChangReleaseLinking = (e: any) => {
        ReleaseLinkingOpen = false;
        setReleaseLinkingOpen(ReleaseLinkingOpen)
    }

    const exportFullListing = () => {

        console.log(AssociatedRelease)

        var allData = [];
        var fileHeader = ['Release', 'Artist', 'Title', 'Tracks']

        for (var i = 0; i < AssociatedRelease.length; i++) {
            var row_data = [];
            row_data.push(AssociatedRelease[i]?.catLogNumber);
            row_data.push(AssociatedRelease[i]?.artistName);
            row_data.push(AssociatedRelease[i]?.title);
            row_data.push(AssociatedRelease[i]?.totalTrack);
            allData.push(row_data)
        }

        CommonUtilities.exportToCSV_Header(fileHeader, [], allData, 'AssociatedReleases.csv');
    }

    return (

        <div className="ws-12">
            <div className="box-content p0">
                <div className="ws-12 pm">
                    <h3 className="capitalize mb pull-left ws-5 ptl">  Associated release ({totalRows})  </h3>

                    <button className="icon-btn info pull-right height35" onClick={exportFullListing}>  <i className="icon-download"></i>   </button>

                    <button className="icon-btn edit pull-right height35" onClick={() => setReleaseLinkingOpen(true)}>
                        Add New Release
                    </button>
                    <button className="icon-btn edit pull-right height35" onClick={() => deleteTask('UpdateReleasesplits')}>
                        <i className="fa fa-save"></i> Update Release splits
                    </button>

                </div>

                {(totalRows > 0) && <table className="newTable">
                    <thead>
                        <tr>
                            <th>Release</th>
                            <th>Artist</th>
                            <th>Title</th>
                            <th>Tracks</th>
                            <th>Operation</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            AssociatedRelease.map((post: any) => (
                                <tr>
                                    <td>
                                        <div className="width170">
                                            {post.catLogNumber}
                                            <button className="icon-btn info pull-right" onClick={() => { setviewContract(true); setviewContractSelect(post) }}>
                                                <i className="icon-price-list"></i>
                                            </button>

                                        </div>
                                    </td>
                                    <td>{post.artistName}</td>
                                    <td>{post.title}</td>
                                    <td>{post.totalTrack}</td>
                                    <td>
                                        <button className="icon-btn edit" onClick={() => setReleaseLinkingOpen(true)}> <i className="icon-edit"></i>  </button>
                                        <button className="icon-btn delete hide" onClick={() => deleteTask('delete')}> <i className="icon-trashcan"></i>  </button>
                                    </td>
                                </tr>
                            ))
                        }

                    </tbody>
                </table>}

                {totalRows === 0 && <div className="alert alert-info mt mrl mbl"> No data to display</div>}

            </div>

            {
                (() => {
                    if (totalRows > 1 && totalRows > 10) {
                        return <Pagination onPageChange={handleNameOnChange} totalRow={totalRows} />
                    }

                    if (viewContract) {
                        return <ViewContractReleaseAsset ViewContractReleaseChange={ViewContractReleaseChange} type="release" viewContract={viewContract} viewContractSelect={viewContractSelect} />
                    }

                    if (deleteJob) {
                        return <DeleteDialogueBox param={deleteJob} message={confirmMessage} onChange={deleteConfirmation} />
                    }

                    if (ReleaseLinkingOpen) {
                        return <ReleaseLinking ReleaseLinkingOpen={ReleaseLinkingOpen} onChangReleaseLinking={onChangReleaseLinking} contractDetails={contractDetails?.contractDetails} />
                    }
                })()
            }
        </div>

    )
}